import Cookies from 'js-cookie';
import { IWebViewActionData, EWebViewActions } from 'Types/index';
import { IAppBarConfig } from '@/interfaces';
import { isNativeAppbarEnabled } from '@/hooks/useAppBarUpdate';
import { COMMON_APPBAR_MENU_ITEMS } from '@/config/appbarConfig';

let lastPageConfig: IAppBarConfig;

export function useWebviewCallback(
    data: IWebViewActionData,
    nativeWebFunc: any,
    getRes?: any
) {
    try {
        const isWebView = Boolean(Cookies.get('webview'));

        if (isWebView && data?.action) {
            if (
                typeof window !== 'undefined' &&
                window?.flutter_inappwebview?.callHandler
            ) {
                window?.flutter_inappwebview
                    ?.callHandler('WebViewConnect', JSON.stringify(data))
                    .then((res: any) => {
                        getRes?.(res);
                    });
            }
        } else {
            nativeWebFunc();
        }
    } catch (e) {
        nativeWebFunc();
        //
    }
}

export const getLastPageAppBarConfig = (): IAppBarConfig => {
    return lastPageConfig;
};

export const updateAppBar = (
    config: IAppBarConfig,
    isPageConfig: boolean = true
) => {
    if (isNativeAppbarEnabled()) {
        // Only append common menu items if menu_items is not explicitly set in config
        const configWithCommonMenuItems: IAppBarConfig = {
            ...config,
            menu_items:
                config.menu_items !== undefined
                    ? config.menu_items
                    : COMMON_APPBAR_MENU_ITEMS,
        };

        if (isPageConfig) {
            lastPageConfig = configWithCommonMenuItems;
        }

        useWebviewCallback(
            {
                action: EWebViewActions.UPDATE_APPBAR,
                action_value: configWithCommonMenuItems,
            },
            () => {}
        );
    }
};
